import widgetFactory from '../widgetFactory';
import responsive from '../../Services/responsive';
import _ from 'lodash';

const widgetName = 'autostartFullScreenVideo';

const LOADING_TIME_REFERENCE = {
  TIME_TO_LOAD_VIDEO: 3150,
  DOWNLOAD_SPEED: 1500,
};

export default widgetFactory(widgetName, {
  _create() {
    this._super(widgetName);

    this.isLoadingVideo = false;
    this.startLoadingVideoTimestamp = Date.now();
    this.averageUserConnection;
    this.elements.$mobileFallback = this.getWidgetElement('mobileFallback');
    this.elements.$videoContainer = this.getWidgetElement('videoContainer');
    this.elements.$videoElement = this.getWidgetElement('video');
    this.elements.videoElement = this.elements.$videoElement.get(0);
    this.minimumNetworkSpeedToDiplayVideo = parseInt(
      this.element[0].getAttribute(
        'data-autostartFullScreenVideo-minimumNetworkSpeedToDiplayVideo'
      ),
      10
    );

    this.elements.videoElement.addEventListener('loadeddata', () => {
      const timeToLoadVideo = Date.now() - this.startLoadingVideoTimestamp;
      this.elements.$videoContainer.addClass('is-loaded');
      this.averageUserConnection =
        (LOADING_TIME_REFERENCE.TIME_TO_LOAD_VIDEO / timeToLoadVideo) *
        LOADING_TIME_REFERENCE.DOWNLOAD_SPEED;
      if (this._networkSpeedIsGoodEnough()) {
        this._updatePresentation();
      } else {
        this.elements.videoElement.pause();
      }
    });

    responsive.registerOnChangeCallback(() => {
      this._updatePresentation();
    });

    this._updatePresentation();
  },

  _updatePresentation() {
    if (this._canPlayVideo()) {
      if (!this.isLoadingVideo) {
        // Jira #OC-5767, hack to force load video on safari
        setTimeout(() => {
          this._loadVideo();
        }, 0);
        this.isLoadingVideo = true;
        return;
      }
      this._showVideo();
      this._playVideo();
    } else {
      this._showMobileFallback();
    }
  },

  _loadVideo() {
    this.elements.videoElement.load();
  },

  _canPlayVideo() {
    const isSmallScreen = responsive.getCurrent() === responsive.SCREEN_WIDTH_SMALL;
    return !isSmallScreen;
  },

  _networkSpeedIsGoodEnough() {
    let networkSpeedIsGoodEnough = true;
    if (!_.isNil(this.averageUserConnection)) {
      networkSpeedIsGoodEnough = this.averageUserConnection > this.minimumNetworkSpeedToDiplayVideo;
    }
    return networkSpeedIsGoodEnough;
  },

  _showVideo() {
    this.elements.$mobileFallback.hide();
    this.elements.$videoContainer.show();
  },

  _playVideo() {
    this.elements.videoElement.play();
  },

  _showMobileFallback() {
    this.elements.$mobileFallback.show();
    this.elements.$videoContainer.hide();
  },
});
